/* eslint-disable */
function type(value) {
    return Object.prototype.toString
        .call(value)
        .replace(/^\[object (.+)\]$/, "$1")
        .toLowerCase();
}
export default {
    isString: function (value) {
        return type(value) === "string";
    },
    isFunction: function (value) {
        return type(value) === "function";
    },
    isArray: function (value) {
        return Array.isArray(value);
    },
    isNumber: function (value) {
        return !this.isArray(value) && value - parseFloat(value) + 1 >= 0;
    },
    isDomElement: function (value) {
        return typeof HTMLElement === "object" || typeof HTMLElement === "function"
            ? value instanceof HTMLElement || (typeof SVGElement !== "undefined" && value instanceof SVGElement)
            : value &&
                typeof value === "object" &&
                value !== null &&
                value.nodeType === 1 &&
                typeof value.nodeName === "string";
    },
    isNodeList: function (value) {
        return type(value) === "nodelist";
    },
};
//# sourceMappingURL=type.js.map